import { motion } from "framer-motion";
import { useState } from "react";
import { useLang } from "../../context/LanguageContext";
import { missionVisionValues } from "../../data/content";
import { ArrowUpRight } from "lucide-react";
import OrbitPattern from "../OrbitPattern";

const ease = [0.22, 1, 0.36, 1];

const MissionVisionValues = () => {
  const { isAr, t } = useLang();
  const [active, setActive] = useState(null);

  return (
    <section
      className="relative bg-[#173F35] text-bg-ivory py-[120px] md:py-[180px] overflow-hidden"
      data-testid="mvv-section"
    >
      <div className="absolute -top-[160px] -end-[140px]">
        <OrbitPattern size={520} opacity={0.10} />
      </div>

      <div className="relative z-10 max-w-[1760px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="flex justify-between items-center text-bg-ivory/65 mb-16">
          <span className="page-meta">— 08</span>
          <span className="page-meta">{t("الرسالة والرؤية والقيم", "Mission, Vision & Values")}</span>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, ease }}
          className="mb-20 max-w-3xl"
        >
          <div className={`${isAr ? "label-meta-ar" : "label-meta"} text-champagne/80 mb-5`}>
            {t("[ مبادئنا الأساسية ]", "[ OUR FOUNDATION ]")}
          </div>
          <h3
            className={`${isAr ? "arabic-title" : "serif-title"} text-bg-ivory`}
            style={{ fontSize: isAr ? "clamp(38px, 4.6vw, 68px)" : "clamp(44px, 5vw, 92px)" }}
          >
            {isAr ? "الرسالة والرؤية والقيم" : (<>Mission, <em className="font-light">Vision & Values</em></>)}
          </h3>
        </motion.div>

        <div className="editorial-rule-dark mb-12" />

        <div className="grid grid-cols-1 md:grid-cols-3">
          {missionVisionValues.map((m, i) => (
            <motion.div
              key={m.key}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1.0, ease, delay: i * 0.12 }}
              onMouseEnter={() => setActive(m.key)}
              onMouseLeave={() => setActive(null)}
              className={`relative p-10 md:p-12 transition-colors duration-700 cursor-hover ${
                i !== 2 ? "md:border-e" : ""
              }`}
              style={{
                borderColor: "rgba(232,211,195,0.22)",
                background: active === m.key ? "rgba(15,47,41,0.6)" : "transparent",
              }}
              data-testid={`mvv-card-${m.key}`}
            >
              <div className="flex justify-between items-start mb-8">
                <span className="page-meta text-champagne/70">0{i + 1}</span>
                <ArrowUpRight
                  size={20}
                  className={`text-champagne transition-transform duration-700 flip-x ${
                    active === m.key ? "translate-x-1 -translate-y-1" : ""
                  }`}
                />
              </div>
              <h4
                className={`${isAr ? "arabic-title" : "serif-title italic font-light"} text-bg-ivory mb-8`}
                style={{ fontSize: isAr ? 32 : 34 }}
              >
                {isAr ? m.ar_title : m.en_title}
              </h4>
              <div className="editorial-rule-dark mb-6" />
              {isAr ? (
                <p className="arabic-title text-bg-ivory/85" dir="rtl" style={{ fontSize: 15, lineHeight: 1.95, fontWeight: 400 }}>
                  {m.ar_body}
                </p>
              ) : (
                <p className="text-bg-ivory/85" style={{ fontSize: 15, lineHeight: 1.8 }}>
                  {m.en_body}
                </p>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionVisionValues;
